import React from 'react';

interface EditIconProps {
  size?: number;
  className?: string;
  color?: string;
}

const EditIcon: React.FC<EditIconProps> = ({ size = 32, className = '', color = '#C5C5D3' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
      className={className}
    >
      <path d="M3.26953 20.0605C2.21484 20.0605 1.41406 19.7904 0.867188 19.25C0.326823 18.7161 0.0566406 17.9284 0.0566406 16.8867V5.68555C0.0566406 4.63737 0.326823 3.84635 0.867188 3.3125C1.41406 2.77865 2.21484 2.51172 3.26953 2.51172H14.1387L12.2246 4.42578H3.38672C2.93099 4.42578 2.58268 4.54622 2.3418 4.78711C2.10091 5.02148 1.98047 5.3763 1.98047 5.85156V16.7207C1.98047 17.196 2.10091 17.5508 2.3418 17.7852C2.58268 18.0195 2.93099 18.1367 3.38672 18.1367H14.5293C14.8613 18.1367 15.1348 18.0195 15.3496 17.7852C15.571 17.5508 15.6816 17.196 15.6816 16.7207V7.9707L17.6055 6.04688V16.8867C17.6055 17.9284 17.3451 18.7161 16.8242 19.25C16.3099 19.7904 15.584 20.0605 14.6465 20.0605H3.26953ZM6.95117 13.5273C6.84049 13.5729 6.73958 13.5501 6.64844 13.459C6.55729 13.3613 6.53451 13.2572 6.58008 13.1465L7.45898 11.2129L16.3652 2.30664L17.8594 3.78125L8.94336 12.6875L6.95117 13.5273ZM18.6016 3.04883L17.1074 1.54492L17.791 0.871094C17.9733 0.695312 18.1849 0.597656 18.4258 0.578125C18.6732 0.558594 18.8783 0.630208 19.041 0.792969L19.2949 1.05664C19.4837 1.23893 19.5749 1.45052 19.5684 1.69141C19.5684 1.93229 19.474 2.15039 19.2852 2.3457L18.6016 3.04883Z" fill={className ? "currentColor" : color} />
    </svg>

  );
};

export default EditIcon;